import type { LegalAcceptance, LegalAcceptanceRequest, ProfileResponse } from '../contracts/viewer';
import type { ApiClient } from './client';

export class MeApi {
  constructor(private readonly client: ApiClient) {}

  async getProfile(signal?: AbortSignal): Promise<ProfileResponse> {
    return this.client.get<ProfileResponse>('/api/me/profile', signal);
  }

  async acceptLegal(request: LegalAcceptanceRequest, signal?: AbortSignal): Promise<LegalAcceptance> {
    return this.client.post<LegalAcceptance>('/api/me/legal-acceptance', request, signal);
  }
}
